import React from "react";
import "../Styles/Disclaimer.css";
import { useDispatch } from "react-redux";
import { updateDisclaimerStatusAct } from "../Redux/Dashboard/Components/Disclaimer/UpdateStatus/UpdateDisclaimerStatusAction";

const Disclaimer = ({ disclaimerData, onAccept }) => {
  const dispatch = useDispatch();

  const handleAccept = () => {
    const payload = {
      title: disclaimerData.title,
      message: disclaimerData.message,
    };
  
    dispatch(updateDisclaimerStatusAct(payload))
      .then((response) => {
        console.log(response); // Ensure the response is logged
        if (response && response.success) {
          onAccept(); // Notify the parent component to hide the disclaimer
        } else {
          console.error("Error updating disclaimer:", response?.error || "Unknown error");
        }
      })
      .catch((error) => console.error("Failed to update disclaimer:", error.message));
  };
  

  if (!disclaimerData) {
    return null; // Don't render anything if there's no disclaimer data
  }


  return (
    <div className="disclaimer-banner desc-tech">
      <div className="banner-content desc-tech">
        <p className="banner-title desc-tech">
          <strong>{disclaimerData.title}</strong>
        </p>
        <p className="desc-tech">{disclaimerData.message}</p>
        <button
          className="btn btn-primary accept-button desc-tech"
          onClick={handleAccept}
        >
          Agree & Continue
        </button>
      </div>
    </div>
  );
};

export default Disclaimer;
